import request from '@/utils/request'

export function getCommonParam(params) {
	return request.get('audit/condition', {
		params,
		auth: true
	})
}
// 获取公共下拉选项数据
export function getCommonOption(params) {
	return request.get('audit/common', {
		params,
		auth: true
	})
}
export function getCommonAuthOption(params) {
	return request.get('audit/common/type', {
		params,
		auth: true
	})
}
// 获取高校
export function getUniversityList(params) {
	return request.get('user/school', {
		params,
		auth: true
	})
}

// 获取操作手册
export function getOperatingManual(params) {
	return request.get('audit/config', {
		params,
		auth: false
	})
}

// 获取操作文件列表
export function getOperatingManualTow(params) {
	return request.get('common/config', {
		params,
		auth: false
	})
}

// 获取模板
export function getTemplates(params) {
	return request.get('user/template', {
		params,
		auth: false
	})
}
// 获取oss配置
export function getOssConfig(params) {
	return request.get('common/upload/config', {
		params,
		auth: false
	})
}
// 获取换取链接
export function getOssUrl(data) {
	return request.post('common/upload/url', data)
}